import { useNavigate } from "react-router-dom"

function NotificationCard({ children, setCard, path }) {
    const navigate = useNavigate();

    const buttonHandler = (e) => {
        setCard(false)
        if(path)
        navigate(path)
    }
    return (
        <div className="notificationCardContainer backdrop">
            <div className="notificationcard">
                <h2>Notification</h2>
                <br />
                {children}
                <button className='btn' onClick={buttonHandler}>OK</button>
            </div>
        </div>
    )
}

export default NotificationCard